import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { CompanyForm } from "@/components/settings/company-form";
import { companyQuery } from "@/lib/loaders";

export const Route = createFileRoute("/_workspace/settings/company")({
  loader: ({ context }) => context.queryClient.ensureQueryData(companyQuery),
  component: SettingsCompanyPage,
});

function SettingsCompanyPage() {
  // Workspace = company: one company per workspace, edited in place.
  const { data: company } = useQuery(companyQuery);
  // Key by company id so switching the active company remounts the form with
  // the new company's values (react-hook-form only reads defaultValues on mount).
  return <CompanyForm key={company?.id ?? "none"} company={company ?? null} />;
}
